var _style, _circle, _g, _path, _path2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#D80027;}\n\t.st2{fill:#FFDA44;}\n\t.st3{fill:#0052B4;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.1,133.6h449.7C437.5,54,353,0,256,0S74.5,54,31.1,133.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,512c97,0,181.5-54,224.9-133.6H31.1C74.5,458,159,512,256,512L256,512z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M345,256c0,49.2-39.9,77.9-89,77.9s-89-28.7-89-77.9s39.9-89,89-89S345,206.8,345,256z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M345,256c0,49.2-39.9,89-89,89s-89-39.9-89-89"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M200.3,233.7h22.3v44.5h-22.3V233.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M289.4,233.7h22.3v44.5h-22.3V233.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M244.9,200.3h22.3v77.9h-22.3L244.9,200.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPf);
export default __webpack_public_path__ + "static/media/pf.0330ccf213d0334fde0158cfd3ef3b10.svg";
export { ForwardRef as ReactComponent };